import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { filterPreset_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterTag_template } from "./filterTag_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class imagesList_template extends vnTemplate {
    protected filterDate: filterDate_template;
    protected filterPreset: filterPreset_template;
    protected filterSimple: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected tagFilter: filterTag_template;
    protected imageHasWaterMarkFilter : filterDropdown_template;
    protected ratioFilter: filterDropdown_template;
    protected orientationFilter: filterDropdown_template;
    protected uploadSourceFilter: filterDropdown_template;

    protected getTemplateHtml(): string {
        return /* html */`
            <div id="list-references">
                <div class="sub-header filter-preset w-justify ">
                    ${this.filterPreset.getHtmlBuild()}
                </div>

                <div class="sub-header w-justify">
                    <div class="w-left">
                        ${this.tagFilter.getHtmlBuild()}
                        ${this.filterDate.getHtmlBuild()}

                        <div>
                            <label class="form-label">Watermark</label>
                            ${this.imageHasWaterMarkFilter.getHtmlBuild()}
                        </div>
                        <div>
                            <label class="form-label">Orientation</label> 
                            ${ this.orientationFilter.getHtmlBuild() } 
                        </div>
                        <div>
                            <label class="form-label">Ratio</label> 
                            ${ this.ratioFilter.getHtmlBuild() }
                        </div>
                        <div>
                            <label class="form-label">Upload Source</label> 
                            ${ this.uploadSourceFilter.getHtmlBuild() }
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-tags"></div>
                   <div id="selected-content_types"></div>
                </div>
            </div>

            <div class="list-header w-justify" >
                <div class="w-left">
                    <button data-bind="click: onClickAdd" class="btn secondary icon i-image-2" type="button">Create Images</button>
                </div>
                <div class="w-center">
                    ${this.filterSimple.getHtmlBuild()}
                </div>
                <div class="w-right">
                    ${this.pagination.getHtmlBuild()}
                </div>
            </div>

            <div class="w-list-results w-video-list list-article" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span>Thumbnail</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'url') }, css: { 'list-sort-desc': orderByAndDirection()=='url_DESC', 'list-sort-asc': orderByAndDirection()=='url_ASC' }">URL</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Uploaded On</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Updated On</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: images">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <span data-bind="text: id"></span>
                                </a>
                            </td>
                            <td class="has-image" data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <img class="thumbnail" data-bind="attr: { src: url }"  alt="" />
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                   <span data-bind="text: name"></span>
                                </a>
                            </td>
                            </td>
                            <td>
                                <div class="flex" style="justify-content: space-between;">
                                    <a style="flex: 1" data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                        <span data-bind="text: url"></span>
                                    </a>
                                    <a class="btn icon border only-icon i-full-size" target="_blank" rel="noopener noreferrer" data-bind="attr: { href: url }"></a>
                                </div>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <span data-bind="text: dateCreated"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickView }">
                                <a data-bind="attr: { href: $parent.viewUrl($data.id) }">
                                    <span data-bind="text: dateUpdated"></span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            `;
    }

    protected getTemplateName(): string {
        return "imagesList-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected initPartial(): void {
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.filterDate = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.filterDate.getTemplateViewModel().startDate(null);
        this.filterDate.getTemplateViewModel().endDate(null);
        this.filterDate.toggleClearButton(true);
        this.filterDate.setLabel("Date Range");

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType("images");

        this.filterSimple = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();

        this.imageHasWaterMarkFilter = new filterDropdown_template('imageHasWaterMarkFilter', this.getTemplateViewModel(), this.caller);
        this.imageHasWaterMarkFilter.setLabel("WaterMark")
        this.imageHasWaterMarkFilter.setOptions([{id : 0, name: 'All'}, {id : 1, name: 'Yes'}, {id : 2, name: 'No'}]);

        this.ratioFilter = new filterDropdown_template("ratioFilter", this.getTemplateViewModel(), this.caller);
        this.ratioFilter.setLabel("Ratio");

        this.orientationFilter = new filterDropdown_template("orientationFilter", this.getTemplateViewModel(), this.caller);
        this.orientationFilter.setLabel("Orientation");

        this.uploadSourceFilter = new filterDropdown_template("uploadSourceFilter", this.getTemplateViewModel(), this.caller);
        this.uploadSourceFilter.setLabel("Upload Source"); 

    }

    protected buildViewModel(): any {
        let self = this;
        return {
            idBrand: ko.observable(null),
            orderBy: ko.observable("dateCreated"),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            orderByDirection: ko.observable("DESC"),
            images: ko.observableArray([]),
            permissions: ko.observableArray(this.initPermissions(["article_list_self", "article_list_brand", 'article_edit'])),
            viewUrl: (id: number): string => `/brand/${this.getTemplateViewModel().idBrand()}/images/view/${id}`,
            onClickAdd: () => {
                self.onClickAdd();
            },
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            onClickView: (data, event) => {
                self.onClickView(data, event);
            },
        };
    }

    public getViewModelForRequest() {
        return {
            filters: {
                dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter(),
                startDate: this.getTemplateViewModel().dateFilter.startDate(),
                startDateRange: this.getTemplateViewModel().dateFilter.fromRange(),
                endDate: this.getTemplateViewModel().dateFilter.endDate(),
                endDateRange: this.getTemplateViewModel().dateFilter.toRange(),
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                tags: this.tagFilter.getTagsForRequest(),
                watermark: this.getTemplateViewModel().imageHasWaterMarkFilter.selectedOption,
                ratio: this.getTemplateViewModel().ratioFilter.selectedOption,
                orientation: this.getTemplateViewModel().orientationFilter.selectedOption,
                uploadSource: this.getTemplateViewModel().uploadSourceFilter.selectedOption,
            },
            orderBy: this.getTemplateViewModel().orderBy,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName(),
            searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType(),
            imagePagination: this.getTemplateViewModel().pagination,
        };
    }

    public setViewModelFromRequest(urlParams) {
        if (urlParams != null) {
            if (urlParams.dateFilterType) {
                this.filterDate.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
            }
            if (urlParams.startDateRange || urlParams.endDateRange) {
                this.filterDate.setRange(urlParams.startDateRange, urlParams.endDateRange);
            }
            if (urlParams.startDate || urlParams.endDate) {
                this.setDateFilters(urlParams.startDate, urlParams.endDate);
            }

            let keywordString = urlParams.keywords;
            if (urlParams.keywords) {
                keywordString = urlParams.keywords.replaceAll("+", " ");
            }
            this.filterSimple.getTemplateViewModel().filterKeyword(keywordString);

            if (urlParams.tags) {
                this.tagFilter.setSelectedTagsFromRequestParams(urlParams.tags);
            } else {
                this.tagFilter.resetTagContainer();
            }

            this.imageHasWaterMarkFilter.setSelectedOption( typeof urlParams.watermark === "undefined" ? 0 : urlParams.watermark);

        }
    }

    public addCreatedPresetToList(response) {
        this.filterPreset.addCreatedPresetToList(response);
    }

    public buildDatePickerCalendar() {
        this.filterDate.buildCalendar();
    }

    public onClickAdd() {
        this.caller.addImage();
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.imagesListReorder();
    }

    public onClickView(data, event) {
        if (event.target.id.indexOf("site-view") == -1) {
            this.caller.viewImage(data.id);
        }
    }

    public setAddButtonShown(isAddButtonShown: boolean) {
        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    private setDateFilters(startDate, endDate) {
        if (startDate) {
            startDate = new Date(startDate.replace(/-/g, "/"));
        }
        if (endDate) {
            endDate = new Date(endDate.replace(/-/g, "/"));
        }
        this.filterDate.setDateRange(startDate, endDate);
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setSearchPresets(presets) {
        this.filterPreset.setSearchPresets(presets);
    }

    public setImages(images: Array<{}>): void {
        this.getTemplateViewModel().images(images);
    }

    public setIdBrand(idBrand) {
        this.getTemplateViewModel().idBrand(idBrand);
    }

    private setTagPreset(idTag: number, tag: string): void {
        this.tagFilter.getTemplateViewModel().idTag(idTag);
        this.tagFilter.getTemplateViewModel().tag(tag);
        this.tagFilter.toggleCloseButton();
    }

    protected setTagFilter(tags) {
        this.tagFilter.setTags(tags);
    }

   public setRatios(ratios){
        this.ratioFilter.setOptions(ratios);
    }

    public setOrientations(orientations){
        this.orientationFilter.setOptions(orientations);
    }

    public setUploadSources(uploadSources, selectedUploadSource){
        this.uploadSourceFilter.setOptions(uploadSources);
        this.getTemplateViewModel().uploadSourceFilter.setSelectedOption(selectedUploadSource);
    } 

    public setFilterSelectedItems(objFilter, urlParams) {
        let splitString = [];

        // Multi select filters.
        if (Array.isArray(urlParams)) {
            urlParams = urlParams.toString();
        }
        if (urlParams) {
            if (typeof urlParams == "string") {
                splitString = urlParams.split(",");
            } else {
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if (!isNaN(Number(id))) {
                    id = Number(id);
                } else {
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        } else {
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/imagesList_template.ts